import landingImage from '../../../../assets/landing.png';

type Props = {
  onShowCaptureRules?: () => void;
};

export default function RegisterPageBottomSection({
  onShowCaptureRules
}: Props) {
  return (
    <div className="mb-4 flex flex-1 flex-col items-center justify-between">
      <div className="flex flex-1 items-center justify-center py-6">
        <img src={landingImage} alt="Landing" className="w-[75%] sm:w-[50%]" />
      </div>

      <div className="buttonSectionStyle">
        <button
          type="button"
          aria-label="Register"
          onClick={() => onShowCaptureRules && onShowCaptureRules()}
          className="w-48 rounded-2xl bg-[#5CB891] px-2 py-4 font-semibold text-white transition-all duration-300 ease-out hover:bg-[#4aa07c]"
        >
          Register
        </button>
      </div>
    </div>
  );
}
